(function () {
  var form   = document.getElementById('experience-feedback-form');
  var input  = document.getElementById('experience-feedback-input');
  var submit = document.getElementById('experience-feedback-submit');
  var bubble = document.getElementById('experience-feedback-bubble');
  if (!form || !input || !bubble) return;

  var lastSent = '';

  form.addEventListener('submit', function (e) { e.preventDefault(); });

  // El botón de enviar solo aparece cuando hay texto escrito.
  function toggleSubmit() {
    if (!submit) return;
    submit.style.display = input.value.trim() ? 'flex' : 'none';
  }

  function trySubmit() {
    var value = input.value.trim();
    if (!value || value === lastSent) return;
    lastSent = value;

    var csrf = document.querySelector('meta[name="csrf-token"]');
    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/javascript',
        'X-CSRF-Token': csrf ? csrf.content : ''
      }
    }).then(function (res) {
      if (res.ok) {
        input.value = '';
        toggleSubmit();
        showBubble();
      }
    });
  }

  input.addEventListener('input', toggleSubmit);

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      trySubmit();
    }
  });

  if (submit) {
    submit.addEventListener('click', function (e) {
      e.preventDefault();
      trySubmit();
    });
  }

  function fadeIn(el) {
    el.style.transition = 'none';
    el.style.opacity    = '0';
    el.style.display    = 'flex';
    void el.offsetHeight;
    el.style.transition = 'opacity 0.3s ease';
    el.style.opacity    = '1';
  }

  function fadeOut(el) {
    el.style.transition = 'opacity 0.4s ease';
    el.style.opacity    = '0';
    setTimeout(function () { el.style.display = 'none'; }, 400);
  }

  function showBubble() {
    fadeIn(bubble);
    setTimeout(function () { fadeOut(bubble); }, 2500);
  }
}());
